<h1 mat-dialog-title class="title"> {{ translationBaseKey + '.' + data.titleResourceKey | translate:{parameter:
  data.toBeMatchedValue} }} </h1>
<div mat-dialog-content class="content">
  <p *ngIf="data.warningResourceKey" class="deletion-warning">{{ data.warningResourceKey | translate }}</p>
  <p>{{ translationBaseKey + '.ConfirmInstruction' | translate:{'parameter': data.toBeMatchedName} }}:</p>

  <mat-form-field appearance="outline">
    <input matInput [(ngModel)]="enteredValue" (ngModelChange)="enteredValue_Changed($event)"
      [attr.aria-label]="translationBaseKey + '.ConfirmInputLabel' | translate:{ parameter: data.toBeMatchedName }">
  </mat-form-field>

</div>

<div mat-dialog-actions>
  <button mat-button (click)="onYesClick()" [disabled]="yesButtonDisabled">{{ translationBaseKey + '.YesButton'
    | translate }}</button>
  <button mat-button (click)="onNoClick()" [attr.cdkFocusInitial]="data.cancelButtonResourceKey ? null : ''">{{ translationBaseKey + '.NoButton' | translate
    }}</button>
  <button *ngIf="data.cancelButtonResourceKey" mat-flat-button color="warn" type="button" class="cancel-deletion-button"
    (click)="onCancelClick()" cdkFocusInitial>{{ data.cancelButtonResourceKey | translate }}</button>
</div>